module.exports = __webpack_public_path__ + "img/darren.0b82a25e.png";